import React, { useContext, useRef } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import classNames from 'classnames';

import '../../../css/QuestionFlyout.scss';
import { LessonMode } from '../../../Constants';
import { register } from '../../../i18n';

import useAccessibilityClick from '../../../hooks/useAccessibilityClick';
import leftRailService from '../../services/LeftRailService';

const SatelliteToggle = observer(() => {
	const t = register('PanelMenu');
	const {
		lessonManager,
		navMenuManager
	} = useContext(MobXProviderContext);

	const openButtonRef = useRef();
	// Bold/selected only when the rail is open and this is the active panel.
	const isSelected = leftRailService.isOpen && navMenuManager.leftRailSelectedTab === 'satellite';

	useAccessibilityClick(openButtonRef, () => {
		leftRailService.toggleSatellite();
	});

	if (lessonManager.playerMode === LessonMode.TEACHER_PRESENTATION) {
		return null;
	}

	if (!lessonManager.shouldShowRelatedTabButton) {
		return null;
	}

	return (
		<div
			ref={openButtonRef}
			aria-controls='related-resources-panel'
			aria-label={!isSelected ? t('openRelatedResources', 'Open Related Resources') : t('closeRelatedResources', 'Close Related Resources')}
			aria-selected={isSelected}
			className={classNames('q-flyout-tab', 'satellite-toggle-button', { selected: isSelected })}
			role='tab'
			tabIndex='0'
		>
			<div className='q-flyout-tab-label'>{t('relatedResources', 'Related Resources')}</div>
		</div>
	);
});

export default SatelliteToggle;
